import React from 'react';
import {ScaleLinear} from 'd3-scale';
import {Margins} from '../../types';
import {AxisDomain, axisLeft, axisRight} from 'd3-axis';
import {select} from 'd3-selection';

interface SimpleVerticalAxisProps {
  scale: ScaleLinear<number, number>;
  margins: Margins;
  amtOfTicks: number;
  tickFormat?: (domainValue: AxisDomain) => string;
  isRight?: boolean;
}

export default class SimpleVerticalAxis extends React.Component<SimpleVerticalAxisProps> {
  private readonly axisElement: React.RefObject<SVGGElement>;

  constructor(props: SimpleVerticalAxisProps) {
    super(props);
    this.axisElement = React.createRef();
  }

  componentDidMount() {
    this.renderAxis();
  }

  componentDidUpdate() {
    this.renderAxis();
  }

  renderAxis() {
    const {scale, amtOfTicks, isRight, tickFormat} = this.props;

    const axisFn = isRight ? axisRight : axisLeft;
    const axis = axisFn(scale)
      .ticks(amtOfTicks)
      .tickFormat(tickFormat ? tickFormat : (domainValue: AxisDomain) => domainValue.toString());

    if (!this.axisElement.current) return null;

    select(this.axisElement.current).call(axis);
  }

  render() {
    const {margins} = this.props;

    return <g ref={this.axisElement} transform={`translate(${margins.left}, 0)`} />;
  }
}
